import { useLocale } from '@mirai/locale';
import { styles, Theme, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React from 'react';

import { HOSTED_FORM_URL } from './FormPaybyrd.constants';
import * as style from './FormPaybyrd.module.css';

export const FormPaybyrd = ({ response, ...others }) => {
  const { locale } = useLocale();

  const { accentLight, base, content } = Theme.get() || {};
  const { configuration: { redirectUrl, orderId, checkoutKey } = {} } = response || {};

  const configs = window.btoa(
    JSON.stringify({
      redirectUrl,
      locale,
      orderId,
      checkoutKey,
      theme: { formBackgroundColor: base, primaryColor: accentLight, textColor: content },
      autoRedirect: true,
      showCancelButton: false,
      skipATMSuccessPage: false,
      compact: true,
    }),
  );

  return (
    <View {...others} className={styles(others.className, style.modal)}>
      <View
        src={`${HOSTED_FORM_URL}?${new URLSearchParams({ checkoutKey, orderId, configs })}`}
        tag="iframe"
        className={style.iframe}
      />
    </View>
  );
};

FormPaybyrd.displayName = 'Mirai:Payments:ButtonPayment:FormPaybyrd';

FormPaybyrd.propTypes = {
  response: PropTypes.object,
};
